import { DMCObject } from "./DMCObject";
import Konva from "konva";

export class DMCWeb extends DMCObject {
  constructor(name, konvaObject, source, isFullscreen) {
    super(name, konvaObject);

    if (name === undefined || konvaObject === undefined) {
      return;
    }

    this.isFullscreen = isFullscreen;
    this.source = source;
  }

  changeWebSource(urlWeb) {
    this.source = urlWeb;
  }

  delete() {}

  deselect() {}

  getType() {
    return "Web";
  }

  loadCorrectSource(DMCObject) {
    this.source = DMCObject.source;
    this.isFullscreen = DMCObject.isFullscreen;
    if (this.source.length > 0) {
      return this.source;
    } else {
      return "";
    }
  }

  copyOption(DMCObject, controllerProject) {
    let newOption = super.copyOption(DMCObject, controllerProject);
    newOption.fill = DMCObject.konvaObjectOption.fill;
    this.loadCorrectSource(DMCObject);
    return newOption;
  }

  createNewObject(DMCObject) {
    let rect = new Konva.Rect(DMCObject.konvaObjectOption);
    rect.opacity(0.5);
    return rect;
  }

  options() {
    return ["Rect", "Web"];
  }

  select() {}

  stopPreview() {}
}
